import { Grid, Card, CardContent, Box, Skeleton } from "@mui/material";

const OrganizationDetail = () => {
  return (
    <Grid sx={{ my: 2 }}>
      <Card
        style={{
          padding: "20px 5px",
          margin: "0 auto",
          borderRadius: "16px",
          background: "rgb(96, 96, 96, 0.05)",
          minHeight: "75vh",
        }}
      >
        <CardContent>
          {/* Breadcrumb title (User Access / Org Name) */}
          <Skeleton
            variant="text"
            sx={{ fontSize: "30px", width: "40%", mb: 3 }}
          />

          {/* Two-column layout: Details | Contacts */}
          <Box
            sx={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 2fr" },
              gap: "24px 48px",
              alignItems: "start",
            }}
          >
            {/* Details column */}
            <Box sx={{ gridColumn: "1", gridRow: "1" }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "16px", mb: 1 }}
              >
                <Skeleton
                  variant="text"
                  sx={{ fontSize: "1.25rem", width: "40%" }}
                />
                <Skeleton
                  variant="rounded"
                  width={70}
                  height={32}
                  sx={{ borderRadius: "16px" }}
                />
              </Box>
              <Skeleton
                variant="rounded"
                height={52}
                sx={{ width: "100%", mb: 3 }}
              />
              <Skeleton variant="rounded" height={52} sx={{ width: "100%" }} />
            </Box>

            {/* Contacts column */}
            <Box sx={{ gridColumn: { xs: "1", md: "2" }, gridRow: "1" }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "16px", mb: 2 }}
              >
                <Skeleton
                  variant="text"
                  sx={{ fontSize: "1.25rem", width: "25%" }}
                />
                <Skeleton
                  variant="rounded"
                  width={70}
                  height={32}
                  sx={{ borderRadius: "16px" }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  mb: 2,
                }}
              >
                <Skeleton variant="rounded" height={52} sx={{ flex: 1 }} />
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton variant="circular" width={30} height={30} />
              </Box>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                {Array.from({ length: 8 }).map((_, idx) => (
                  <Skeleton
                    key={`contact-field-${idx}`}
                    variant="rounded"
                    height={52}
                    sx={{ width: "calc(50% - 10px)" }}
                  />
                ))}
              </Box>
            </Box>

            {/* Group Access - full width row */}
            <Box sx={{ gridColumn: "1 / -1", gridRow: "2" }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "16px", mb: 2 }}
              >
                <Skeleton
                  variant="text"
                  sx={{ fontSize: "1.25rem", width: "15%" }}
                />
                <Skeleton
                  variant="rounded"
                  width={170}
                  height={32}
                  sx={{ borderRadius: "16px" }}
                />
                <Skeleton
                  variant="rounded"
                  width={170}
                  height={32}
                  sx={{ borderRadius: "16px" }}
                />
              </Box>
              <Skeleton variant="rounded" sx={{ width: "100%" }} height={280} />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default OrganizationDetail;
